module.exports = __webpack_public_path__ + "img/2.913745f0.png";